<template>
  <div style="padding: 0px 24px;">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="门店">
        <el-select v-model="formInline.md" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始年月">
        <el-date-picker type="date" placeholder="选择日期" v-model="formInline.ksny"></el-date-picker>
      </el-form-item>
      <el-form-item label="结束年月">
        <el-date-picker type="date" placeholder="选择日期" v-model="formInline.jsny"></el-date-picker>
      </el-form-item>
      <el-form-item label="合同号">
        <el-input v-model="formInline.hth"></el-input>
      </el-form-item>
      <el-form-item label="品牌">
        <el-input v-model="formInline.pp"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" class="chaxun">查询</el-button>
        <!-- <el-button type="warning" @click="getList" class="chaxun">重置</el-button> -->
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100% !important;"  border show-summary>
      <el-table-column label="序号" width="50">
        <template slot-scope="scope">{{scope.$index+1}}</template>
      </el-table-column>
      <el-table-column prop="FDMC" label="门店" ></el-table-column>
      <el-table-column prop="HTH" label="合同号" ></el-table-column>
      <el-table-column prop="NAME" label="品牌" ></el-table-column>
      <el-table-column prop="WLDW_NAME" label="商户名" width="180"></el-table-column>
      <el-table-column prop="RQ" label="月结" ></el-table-column>
      <el-table-column prop="XSSL" label="销售数量" ></el-table-column>
      <el-table-column prop="XSJE" label="销售金额" ></el-table-column>
      <el-table-column prop="ZKJE" label="折扣金额" ></el-table-column>
      <el-table-column prop="YHJE" label="优惠金额" ></el-table-column>
      <el-table-column label="操作" >
        <template slot-scope="scope">
          <el-button type="text" @click="OpenDialog(scope.row)">品牌日销售明细</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer title="品牌日销售明细" :visible.sync="dialogTableVisible"  direction="rtl"  size="50%">
      <el-table :data="gridData" :height="conheight" border>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">{{scope.$index+1}}</template>
        </el-table-column>
        <el-table-column property="NAME" label="商品名称"></el-table-column>
        <el-table-column property="BARCODE" label="商品条码"></el-table-column>
        <el-table-column property="XSSL" label="销售数量"></el-table-column>
        <el-table-column property="XSJE" label="销售金额"></el-table-column>
        <el-table-column property="ZKJE" label="折扣金额"></el-table-column>
        <el-table-column property="YHJE" label="优惠金额"></el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script>

export default {
  components: { 
  },
  name: "fkqkd",
  data() {
    return {
      options: [{value: '海雅百货南山店',label: '海雅百货南山店'}, 
      {value: '海雅百货东莞东城店',label: '海雅百货东莞东城店'},
      // {value: '海雅百货东莞南城店',label: '海雅百货东莞南城店'},
      {value: '海雅缤纷城购物中心',label: '海雅缤纷城购物中心'},
      {value: '中山海雅缤纷天地',label: '中山海雅缤纷天地'}],
      tableData:[],
      formInline: {
        md:'',
        ksny:'',
        jsny:new Date(),
        hth:'',
        pp:'',
      },
      user:JSON.parse(sessionStorage.currentUser),
      conheight: window.innerHeight-136,
      dialogTableVisible: false,
      gridData: []
    };
  },
  methods: {
    OpenDialog(row){
      this.dialogTableVisible=true;//打开弹出层
      let sql = "select * from V_ZSPT_XSCX_ITEM where WLDW='"+row.WLDW+"' and RQ ='"+row.RQ+"' and hth='"+row.HTH.replaceAll("NO:","")+"' and FDMC='"+row.FDMC+"'";
      this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
        if(resp.data.result.length>0){
          this.gridData = resp.data.result;
        }
      });
    },
    onSubmit() {
      this.tableData = [];
      let sql = "select * from V_ZSPT_XSCX where WLDW='"+this.user.account.replaceAll("SZHY","")+"'";
      if(this.formInline.md.length>0){
        sql += " and instr(FDMC,'"+this.formInline.md+"',1,1)>0";
      }
      if(this.formInline.ksny!=null && this.formInline.ksny!='' && this.formInline.jsny!=null && this.formInline.jsny!=''){
        sql += " and RQ BETWEEN '"+this.getDate(this.formInline.ksny)+"' and '"+this.getDate(this.formInline.jsny)+"'";
      }
      // else{
      //   sql += " and RQ BETWEEN to_char(TRUNC(sysdate,'MM'),'yyyy-mm-dd') and to_char(LAST_DAY(sysdate),'yyyy-mm-dd')";
      // }

      if(this.formInline.hth.length>0){
        sql += " and instr(HTH,'"+this.formInline.hth+"',1,1)>0";
      }
      if(this.formInline.pp.length>0){
        sql += " and instr(NAME,'"+this.formInline.pp+"',1,1)>0";
      }
      sql += " order by RQ desc";
      this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
        if(resp.data.result.length>0){
          this.tableData = resp.data.result;
        }
      });
    },
    getList(){
      let sql = "select * from V_ZSPT_XSCX where RQ BETWEEN to_char(add_months(sysdate,-1),'yyyy-mm-dd') and to_char(sysdate,'yyyy-mm-dd') and WLDW='"+this.user.account.replaceAll("SZHY","")+"' order by RQ desc";
      this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
        if(resp.data.result.length>0){
          this.tableData = resp.data.result;
        }
      });
    },
    getDate(currentDate){
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = year+"-"+month+"-"+day;
      return formattedDate;
    }
  },
  mounted(){
    this.getList();
    let currentDate = new Date(); // 获取当前日期和时间
    currentDate.setMonth(currentDate.getMonth() - 1); // 将月份减去1
    this.formInline.ksny=currentDate;
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
/deep/ .el-table .cell{
  padding: 0px !important;
  text-align: center !important;
}
/deep/ .el-table th{
  // border-right:1px solid #000 !important;
  // border-bottom:1px solid #000 !important;
  .cell{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #292B44;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
/deep/ .el-table td{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #292B44;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  // border-right:1px solid #000 !important;
  // border-bottom:1px solid #000 !important;
}
/deep/ .el-form-item--small .el-form-item__label{
  line-height: 48px !important;
  height: 48px !important;
  color: #292B44 !important;
  font-size: 14px;
}
/deep/ .el-form-item--small .el-form-item__content{
  line-height: 48px !important;
  height: 48px !important;
}
/deep/ .el-form-item el-form-item--small{
  margin: 0px !important;
  line-height: 48px !important;
  height: 48px !important;
}
/deep/ .el-form-item--small.el-form-item{
  margin: 0px !important;
  line-height: 48px !important;
  height: 48px !important;
  padding-right: 32px !important;
}
/deep/ .demo-form-inline{
  // height: 48px !important;
  // line-height: 48px !important;
  padding: 8px 0px !important;
}
/deep/ .chaxun{
  span{
    font-size:14px !important;
  }
}
/deep/ .el-drawer__header{
  margin-bottom: 8px;
  font-weight: 400;
  font-size: 14px;
  color: #292B44;
}
</style>